export default {
  buttons: {
    go_to_basket: 'Zum Warenkorb',
  },
};
